import { useToastStore } from '@dabble/quillui';

export function useToast() {
  const toastStore = useToastStore();

  function showToast(
    type: 'success' | 'warning' | 'info' | 'danger',
    message: string,
    details?: string,
    closable?: boolean,
  ) {
    toastStore.toast[type]({
      message,
      details,
      closable: closable || false,
    });
  }

  return {
    showToast,
  };
}
